import NextImage from 'next/image';
import { useCoralBreakpoints } from '@krakentech/coral';
import { useIsClient } from '@krakentech/utils';

import LeepLogo from '@/public/images/logos/leep.png';
import NautilusLogo from '@/public/images/logos/nautilus-dark.svg';
import PwlLogo from '@/public/images/logos/pwl-dark.svg';
import StwLogo from '@/public/images/logos/stw-cropped.png';

import { LogoConfig } from './index.types';

const logos: Record<string, LogoConfig> = {
  nautilus: {
    src: NautilusLogo,
    desktop: {
      width: 240,
      height: 54,
    },
    mobile: {
      width: 200,
      height: 44,
    },
  },
  pwl: {
    src: PwlLogo,
    desktop: {
      width: 300,
      height: 80,
    },
    mobile: {
      width: 240,
      height: 60,
    },
  },
  leep: {
    src: LeepLogo,
    desktop: {
      width: 260,
      height: 54,
    },
    mobile: {
      width: 240,
      height: 50,
    },
  },
  stw: {
    src: StwLogo,
    desktop: {
      width: 160,
      height: 80,
    },
    mobile: {
      width: 120,
      height: 60,
    },
  },
};

const Logo = () => {
  const isClient = useIsClient();
  const { isMaxMd } = useCoralBreakpoints();

  const isMaxMdBreakpoint = isClient && isMaxMd;

  const brand = process.env.NEXT_PUBLIC_THEME as string;
  const logoAlt = process.env.NEXT_PUBLIC_COMPANY_NAME ?? '';

  return (
    <NextImage
      priority
      src={logos[brand].src}
      alt={logoAlt}
      width={
        isMaxMdBreakpoint
          ? logos[brand].mobile.width
          : logos[brand].desktop.width
      }
      height={
        isMaxMdBreakpoint
          ? logos[brand].mobile.height
          : logos[brand].desktop.height
      }
    />
  );
};

export default Logo;
